module.exports = __webpack_public_path__ + "img/liberapay.6752d848.svg";